import type { OpenWithdrawPopupOptions } from "./WithdrawPopup.types";

export const WITHDRAW_POPUP_EVENT = "show-withdraw-popup";
export const CLOSE_WITHDRAW_POPUP_EVENT = "close-withdraw-popup";

export const openWithdrawPopup = (options?: OpenWithdrawPopupOptions) => {
  window.dispatchEvent(
    new CustomEvent(WITHDRAW_POPUP_EVENT, {
      detail: options || {},
    })
  );
};

export const closeWithdrawPopup = () => {
  window.dispatchEvent(new CustomEvent(CLOSE_WITHDRAW_POPUP_EVENT));
};
